<template>
	<page-text>
		<h1>Правила сервиса</h1>
	</page-text>
</template>

<script>
import PageText from 'elysium-common/components/page/text';
import VueRouter from 'vue-router';

export default {
	components: {
		PageText
	},
	asyncData({ store, route, router, http }) {
		const { privacyPolicyFileUrl } = store.state.regionProfile;
		if (privacyPolicyFileUrl) {
			return Promise.reject({
				message: 'Moved Permanently',
				code: 301,
				data: privacyPolicyFileUrl,
			});
		}

		return Promise.resolve();
	}
};
</script>



// WEBPACK FOOTER //
// Terms.vue?02d678f4